import { Logo } from "@/shared/base/components/Logo/Logo";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  useTheme,
} from "@mui/material";
import TeamLogo from "@/assets/images/fake_team_logo.png";
import TeamNameImage from "@/assets/images/fake_team_name.png";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { Image } from "@/shared/base/components/Image/Image";
import { useRouter } from "next/router";
import { TeamConfig, useTeamConfig } from "@/global/hooks/useTeamConfig";
import Link from "next/link";
import { AiOutlineMenu } from "react-icons/ai";
import { routes } from "@/global/routes";
import OptionsMenu from "@/shared/modules/OptionsMenu/OptionsMenu";
import { v4 as uuid } from "uuid";
import NextImage from "next/image";
import {
  createUrlFromNextRouter,
  extractUrlParams,
} from "@/global/utils/utils";

interface Props {
  renderCenterElements?: () => React.ReactNode;
  renderRightElements?: () => React.ReactNode;
  isSticky?: boolean;
}

export function TopHeaderLayout(props: Props) {
  const theme = useTheme();
  const { md: mdUp } = useCssMediaQuery("up");
  const { lg: lgDown, md: mdDown } = useCssMediaQuery("down");
  const teamConfig = useTeamConfig();
  const router = useRouter();
  const { teamSchema, images, defaultRoute: defaultUrl } = useTeamConfig();

  const handleLogoClick = () => {
    window.location.href = createUrlFromNextRouter(defaultUrl, teamConfig);
  };

  return (
    <Paper
      id="flex-app-header"
      square={true}
      variant="outlined"
      sx={{
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        position: props?.isSticky ? "sticky" : "static",
        top: "0",
        backgroundColor: theme.palette.common.white,
        zIndex: "999",
      }}
    >
      <Container maxWidth={"xl"}>
        <Stack
          py={2}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={mdDown ? 1 : 3}
        >
          <Stack
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            flex={lgDown ? "unset" : 1}
          >
            {images.logoImage ? (
              <Box
                width={`${extractUrlParams(images.logoImage).width}px`}
                height={`${extractUrlParams(images.logoImage).height}px`}
              >
                <img
                  onClick={handleLogoClick}
                  alt={teamSchema}
                  src={images.logoImage}
                  style={{
                    cursor: "pointer",
                    width: `${extractUrlParams(images.logoImage).width}px`,
                    height: `${extractUrlParams(images.logoImage).height}px`,
                    objectFit: "contain",
                  }}
                />
              </Box>
            ) : null}
          </Stack>

          <Stack alignItems={"center"} flexGrow={1}>
            {props?.renderCenterElements?.()}
          </Stack>
          <Stack alignItems={"flex-end"} flex={lgDown ? "unset" : 1}>
            {props?.renderRightElements?.()}
          </Stack>
        </Stack>
      </Container>
    </Paper>
  );
}
